"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      display: 'flex',
      margin: spacing(1, 0)
    }
  };
}); // TODO Find a easier way to get the name of the country selected in the "Create a new Alyce contact" page

var COUNTRY_MARKETPLACE = {
  1: 'Unites States Marketplace',
  2: 'Canada Marketplace',
  3: 'United Kingdom Marketplace',
  4: 'Ireland Marketplace',
  5: 'Austria Marketplace',
  6: 'Belgium Marketplace',
  7: 'France Marketplace',
  8: 'Germany Marketplace',
  9: 'Italy Marketplace',
  10: 'Luxembourg Marketplace',
  11: 'Netherlands Marketplace',
  12: 'Poland Marketplace',
  13: 'Portugal Marketplace',
  14: 'Spain Marketplace',
  15: 'Sweden Marketplace',
  16: 'Switzerland Marketplace',
  17: 'Denmark Marketplace',
  18: 'Finland Marketplace',
  19: 'Australia Marketplace',
  20: 'India Marketplace',
  21: 'Mexico Marketplace',
  22: 'Singapore Marketplace',
  999: 'Global Marketplace'
};

var MarketplaceNotice = function MarketplaceNotice(_ref2) {
  var productsCount = _ref2.productsCount,
      countryId = _ref2.countryId,
      countryName = _ref2.countryName,
      filtersCount = _ref2.filtersCount,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? {} : _ref2$classes;
  var defaultClasses = useStyles();
  var marketplaceCountryName = countryName ? "".concat(countryName, " Marketplace") : COUNTRY_MARKETPLACE[countryId];
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: (0, _classnames["default"])(defaultClasses.root, classes.root)
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    color: "grey.main",
    fontSize: "0.75rem",
    lineHeight: 1.33,
    mr: 1
  }, "Viewing ", productsCount.toLocaleString('en'), " gift options ", marketplaceCountryName, ' - ', filtersCount, " filter", (filtersCount > 1 || filtersCount === 0) && 's', " applied"));
};

var _default = MarketplaceNotice;
exports["default"] = _default;